import { PlayerEvent } from 'bitmovin-player';
export function setupMediaSessionActionHandlers(player, sourceConfig, _streamObject) {
    function handlePlaying() {
        player.off(PlayerEvent.Playing, handlePlaying);
        if (!('mediaSession' in navigator)) {
            return;
        }
        setMediaSessionMetadata();
        setupMediaSessionActionHandlers();
        updatePositionState();
    }
    function handlePaused() {
        player.off(PlayerEvent.Paused, handlePaused);
        if (!('mediaSession' in navigator)) {
            return;
        }
        navigator.mediaSession.playbackState = 'paused';
    }
    function handlePlay() {
        player.off(PlayerEvent.Play, handlePlay);
        if (!('mediaSession' in navigator)) {
            return;
        }
        navigator.mediaSession.playbackState = 'playing';
    }
    function handleSourceUnloaded() {
        player.off(PlayerEvent.SourceUnloaded, handleSourceUnloaded);
        if (!('mediaSession' in navigator)) {
            return;
        }
        navigator.mediaSession.setPositionState(undefined);
    }
    function handleDestroy() {
        player.off(PlayerEvent.Destroy, handleDestroy);
        if (!('mediaSession' in navigator)) {
            return;
        }
        navigator.mediaSession.setPositionState(undefined);
    }
    function handlePlaybackSpeedChanged() {
        player.off(PlayerEvent.PlaybackSpeedChanged, handlePlaybackSpeedChanged);
        updatePositionState();
    }
    player.on(PlayerEvent.Playing, handlePlaying);
    player.on(PlayerEvent.Paused, handlePaused);
    player.on(PlayerEvent.Play, handlePlay);
    player.on(PlayerEvent.SourceUnloaded, handleSourceUnloaded);
    player.on(PlayerEvent.Destroy, handleDestroy);
    player.on(PlayerEvent.PlaybackSpeedChanged, handlePlaybackSpeedChanged);
    function setMediaSessionMetadata() {
        const metadata = {
            title: sourceConfig.title,
            artist: _streamObject.metadata.broadcaster || ''
        };
        if (sourceConfig.poster || _streamObject.metadata.poster) {
            metadata.artwork = [
                {
                    src: sourceConfig.poster || _streamObject.metadata.poster
                }
            ];
        }
        navigator.mediaSession.metadata = new MediaMetadata(metadata);
    }
    function setupMediaSessionActionHandlers() {
        const defaultSkipTime = 10;
        const actionHandlers = [
            {
                action: 'seekbackward',
                handler: (details) => {
                    const skipTime = details.seekOffset || defaultSkipTime;
                    player.seek(Math.max(player.getCurrentTime() - skipTime, 0));
                    updatePositionState();
                }
            },
            {
                action: 'seekforward',
                handler: (details) => {
                    const skipTime = details.seekOffset || defaultSkipTime;
                    player.seek(Math.min(player.getCurrentTime() + skipTime, player.getDuration()));
                    updatePositionState();
                }
            },
            {
                action: 'seekto',
                handler: (details) => {
                    if (details.seekTime) {
                        player.seek(details.seekTime);
                    }
                    updatePositionState();
                }
            },
            {
                action: 'play',
                handler: () => player.play()
            },
            {
                action: 'pause',
                handler: () => player.pause()
            },
            {
                action: 'stop',
                handler: () => player.unload()
            }
        ];
        for (const { action, handler } of actionHandlers) {
            try {
                navigator.mediaSession.setActionHandler(action, handler);
            }
            catch (error) {
                console.warn(`The media session action '${action}' is not supported yet.`, error);
            }
        }
    }
    function updatePositionState() {
        if ('setPositionState' in navigator.mediaSession) {
            navigator.mediaSession.setPositionState({
                duration: player.getDuration(),
                playbackRate: player.getPlaybackSpeed(),
                position: player.getCurrentTime()
            });
        }
    }
}
